import { useEffect, useState } from "react";
import { enqueueSnackbar } from "notistack";
import { errorsMessage } from "../../helpers";
import useLoadingStore from "../../store/loading";
import { api } from "../../services/api";
import useModalStore from "../../store/modalStore";

export function usePublicity(props) {
  const [open, setOpen] = useState(false);
  const [results, setResults] = useState();
  const [publicity, setPublicity] = useState({});
  const { setLoadingTable } = useLoadingStore(state => state);
  const { modalOpen, showModal, hideModal } = useModalStore(state => state);
  const id = props?.imovelId || null;

  useEffect(() => {
    if (id) {
      getList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const getList = async () => {
    try {
      setLoadingTable(true);

      const { data } = await api.get(`/imoveis/${id}`);

      setResults(data?.data?.publicidades || []);
    } catch (err) {
      errorsMessage(err, enqueueSnackbar);
    } finally {
      setLoadingTable(false);
    }
  };

  const handleOpen = (status = true) => {
    setOpen(status);
    if (!status) setPublicity({});
  };

  const handleEdit = item => {
    setPublicity(item);
    handleOpen();
  };

  const handleShow = item => {
    setPublicity(item);
    showModal();
  };

  const handleClose = () => {
    setPublicity(null);
    hideModal();
  };

  const handleDelete = async () => {
    try {
      await api.delete(
        `/imoveis/publicidades/${id}/destroy-publicidade/${publicity.Id}`
      );
      handleClose();
      getList();
      enqueueSnackbar("Registro deletado com sucesso", {
        variant: "success"
      });
    } catch (err) {
      errorsMessage(err, enqueueSnackbar);
    }
  };

  return {
    results,
    open,
    handleOpen,
    publicity,
    handleEdit,
    getList,
    handleShow,
    modalOpen,
    hideModal,
    handleClose,
    handleDelete
  };
}
